module.exports = __webpack_public_path__ + "img/28.f1dd1893.svg";